<template>
<div class="red-icon flex items-center justify-center" :style="iconStyle">
  <img :src="iconURL" style="width: 50%;height: 50%;" >
</div>
</template>

<script>
export default {
  name: 'RedIcon',
  props: {
    icon: String,
    size: {
      type: Number,
      default: 88,
    },
    rounded: {
      type: Number,
      default: 24,
    }
  },
  computed: {
    iconStyle() {
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        'border-radius': this.rounded + 'px',
      }
    },
    iconURL() {
      return require('@/assets/home/' + this.icon)
    }
  }
}
</script>

<style scoped lang="scss">
.red-icon{
  background: #E84E4E;
}
</style>
